"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProjectConfiguration = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const merge_1 = __importDefault(require("lodash/merge"));
// Initialize default configuration
const projectConfig = {
    mapDefaultCenter: { lon: -73.6131, lat: 45.5041 },
    separateAdminLoginPage: false,
    projectShortname: 'default',
    userDiskQuota: '1gb',
    maxFileUploadMB: 256,
    sections: {},
    captchaComponentType: 'simple'
};
/**
 * Set the project configuration options. Backend and frontend will get this
 * data in a different way and will typically call this function to set the
 * configurations.
 *
 * @param config The configuration options to set
 * @returns
 */
const setProjectConfiguration = (config) => Object.keys(config).forEach((configKey) => typeof projectConfig[configKey] === 'object'
    ? (0, merge_1.default)(projectConfig[configKey], config[configKey])
    : (projectConfig[configKey] = config[configKey]));
exports.setProjectConfiguration = setProjectConfiguration;
exports.default = projectConfig;
//# sourceMappingURL=project.config.js.map